export * from "../global/store-locator";
